"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsTimer = void 0;
var MetricsTimer = (function () {
    function MetricsTimer() {
        this.completedTime = 0;
    }
    MetricsTimer.prototype.reset = function () {
        this.completedTime = 0;
        this.startTime = undefined;
    };
    Object.defineProperty(MetricsTimer.prototype, "active", {
        get: function () {
            return Number.isFinite(this.startTime);
        },
        set: function (active) {
            if (!Number.isFinite(this.startTime)) {
                if (active) {
                    this.startTime = Date.now();
                }
            }
            else {
                if (!active) {
                    this.completedTime += Date.now() - this.startTime;
                    this.startTime = undefined;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MetricsTimer.prototype, "totalTime", {
        get: function () {
            var result = this.completedTime;
            if (Number.isFinite(this.startTime)) {
                result += Date.now() - this.startTime;
            }
            return result;
        },
        enumerable: false,
        configurable: true
    });
    return MetricsTimer;
}());
exports.MetricsTimer = MetricsTimer;
//# sourceMappingURL=MetricsTimer.js.map